import { del, get, post, put } from '../utils/axios'

export const getPositionAPI = async (param) => {
  return await get('positions', param)
}

export const updatePositionAPI = async (param, body) => {
  return await put('positions', param, body)
}
export const createPositionAPI = async (param) => {
  return await post('positions', param)
}

export const deletePositionAPI = async (param) => {
  return await del('positions', param)
}

export const getPositionExpandAPI = async (param) => {
  return await get('search/position/th-eng', param)
}